import { render, staticRenderFns } from "./ProductionWorkflow.vue?vue&type=template&id=528f23ed&scoped=true&"
import script from "./ProductionWorkflow.vue?vue&type=script&lang=js&"
export * from "./ProductionWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ProductionWorkflow.vue?vue&type=style&index=0&id=528f23ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f23ed",
  null
  
)

export default component.exports